import { ButtonBase, Typography } from '@material-ui/core'

import { LocalizedLink } from '../../routes/localizedRoutes'
import { Gateway } from '../../types/gateway'
import useStyles from './styles/GatewayRowMobile.styles'

interface GatewayRowMobileProps {
  data: Gateway
  hasAccessToViewGateway: boolean | undefined
}
const GatewayRowMobile: React.FC<GatewayRowMobileProps> = ({
  data,
  hasAccessToViewGateway
}) => {
  const classes = useStyles()
  return (
    <ButtonBase
      className={classes.tableRow}
      component={LocalizedLink}
      to={
        hasAccessToViewGateway
          ? `/gateway/${data.basicDetails.gatewayId}/details`
          : ''
      }>
      <div className={classes.nameCell}>
        <Typography variant="body1">{data.basicDetails.name}</Typography>
      </div>
      <div className={classes.nameCell}>
        <Typography variant="body1">{data.basicDetails.entity}</Typography>
      </div>{' '}
    </ButtonBase>
  )
}
export default GatewayRowMobile
